export default __webpack_public_path__ + "static/media/Messages.0a0a3b6b.svg";